import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import {
  BreakConfigurationFragment,
  TimePlanningPlannedBreakBreakTypeEnum as BreakType,
} from 'generated/resources/graphql'

import Popover from 'modules/core/components/PopoverMenu'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import AddPlannedBreakModal from 'modules/shift_management/components/Settings/SavedShifts/AddPlannedBreakModal'

interface Props {
  onAddShift?: () => void
  onAddBreak: (breakConfiguration: BreakConfigurationFragment, breakType: BreakType) => void
}

const AddFieldButton = ({ onAddShift, onAddBreak }: Props) => {
  const [isBreaksModalOpen, setIsBreaksModalOpen] = React.useState(false)

  const onOpenBreaksModal = () => {
    setIsBreaksModalOpen(true)
    track(trackingEvents.shiftManagement.addBreakStart, { from: 'work-schedules' })
  }

  return (
    <>
      <Popover type="list">
        <Popover.Trigger>
          <Button type="secondary" iconName="add" />
        </Popover.Trigger>
        <Popover.Content side="bottom" align="end" width="s200">
          {onAddShift && (
            <Popover.TouchableOption
              onClick={onAddShift}
              title={i18n.t('settings.work_schedule.period_section.add_shift')}
            />
          )}
          <Popover.TouchableOption
            onClick={onOpenBreaksModal}
            title={i18n.t('settings.work_schedule.period_section.add_break')}
          />
        </Popover.Content>
      </Popover>

      {isBreaksModalOpen && (
        <AddPlannedBreakModal
          onClose={() => setIsBreaksModalOpen(false)}
          onAddBreak={onAddBreak}
          from="work-schedules"
        />
      )}
    </>
  )
}

export default AddFieldButton
